import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { useAppSelector } from '@/store/hooks';

export type ReviewsState = {
  isAssigning: boolean;
};

export const initialState: ReviewsState = {
  isAssigning: false,
};

const ReviewsSlice = createSlice({
  initialState,
  name: 'reviews',
  reducers: {
    RESET() {
      return initialState;
    },
    SET_IS_ASSIGNING(state, action: PayloadAction<boolean>) {
      state.isAssigning = action.payload;
    },
  },
});

export const reviewsReducer = ReviewsSlice.reducer;
export const reviewsActions = ReviewsSlice.actions;

export function useReviewsSelector(): ReviewsState {
  return useAppSelector((state) => state.reviews);
}
